import { forwardRef } from "react";
import { useRender } from "@base-ui-components/react/use-render";
import { mergeProps } from "@base-ui-components/react/merge-props";
import { paperClasses, PaperVariants } from "./Paper.style";

export type PaperProps = useRender.ComponentProps<"div"> & PaperVariants;

const Paper = forwardRef<HTMLDivElement, PaperProps>((props, ref) => {
  const {
    render,
    className,
    square,
    variant = "elevation",
    elevation = "md",
    ...rest
  } = props;

  const element = render ?? <div />;

  const defaultProps: useRender.ElementProps<"div"> = {
    ref,
    className: paperClasses({
      square,
      variant,
      elevation: variant === "outlined" ? "none" : elevation,
      class: className,
    }),
  };

  const renderElement = useRender({
    render: element,
    props: mergeProps<"div">(defaultProps, rest),
  });

  return renderElement;
});

Paper.displayName = "Paper";

export default Paper;
